import { h } from 'preact';
// import Store from 'store/store';
import * as categories from '../categories';
import * as evidonCategories from './categories';
import * as queue from '../queue';
import { dispatchEvent } from '../dispatchEvent';

export { default as Pixel } from '../Pixel';
export { maybeHandle } from '../maybeHandle';
export { default as connectToOneTrust } from '../oneTrust/connectToOneTrust';
export { default as createPixelComponent } from '../createPixelComponent';

export { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING } from '../constants';

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', { categories: allowedCategories });
	queue.drain(allowedCategories);
});

if (typeof window !== 'undefined' && window.evidon) {
	let otherCallbacks = [window.evidon.priorConsentCallback];
	let lastCats;
	let priorConsentCallback = (cats, ...rest) => {
		if (cats === lastCats) {
			return;
		}
		lastCats = cats;
		otherCallbacks.forEach(callback => {
			try {
				callback?.(cats, ...rest);
			} catch (e) {}
		});
		evidonCategories.set(cats);
	};
	const protectCallback = (evidon) => {
		Object.defineProperty(evidon, 'priorConsentCallback', {
			get() {
				return priorConsentCallback;
			},
			set(fn) {
				otherCallbacks.push(fn);
			}
		});
	};
	protectCallback(window.evidon);
	let _evidon = window.evidon;
	Object.defineProperty(window, 'evidon', {
		get() {
			return _evidon;
		},
		set(o) {
			protectCallback(o);
			_evidon = o;
		}
	});
}